import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useAnalytics} from '@/services/analytics/hooks/useAnalytics';
import {useTranslation} from '@/services/i18n/hooks/useTranslation';
import {addNotification} from '@/features/notifications/slices/notifications-slice';
import {EVENTS} from '@/services/analytics/constants';
import {createErrorNotification, getAnalyticsSourceType} from '@/utils/error-utils';

export const useErrorHandler = () => {
  const dispatch = useDispatch();
  const {trackEvent} = useAnalytics();
  const {t} = useTranslation();

  const handleError = useCallback((appError, options = {}) => {
    if (!appError) {
      return;
    }

    const error = appError?.original || appError;
    const sourceType = getAnalyticsSourceType(error);
    trackEvent(EVENTS.ERROR, error, {sourceType, ...options});

    const notification = createErrorNotification(appError, t);
    dispatch(addNotification(notification));
  }, [dispatch, trackEvent, t]);

  return {handleError};
};
